import { createApp } from 'vue'
import App from './App.vue'
import './main.css'  
import router from './router'       
import { createPinia } from 'pinia'
import i18n from './i18n'
import { Vue3Lottie } from 'vue3-lottie'


createApp(App)
.use(router)
.use(createPinia())
.use(i18n)
.component('Vue3Lottie', Vue3Lottie)
.mount('#app')
